import * as React from "react";
import * as ReactDOM from "react-dom";
import { InputBase, InputContainer, InputHint, IInputBaseProperties } from "../input";


export interface ITextBoxProperties extends IInputBaseProperties
{
    /**
     * Enthält alle Child-Elemente.
     */
    children?: JSX.Element | JSX.Element[],

    /**
     * Inline-Style.
     */
    style?: React.CSSProperties,

    /**
     * Anzeigetext der Checkbox.
     */
    label?: string,

    /**
     * Setzt einen Hilfetext.
     */
    hint?: string | JSX.Element
}

export class TextBox extends React.Component<ITextBoxProperties>
{
    /**
     * Gibt eine <label /> Element zurück. Falls nötig.
     */
    private getLabel()
    {
        if (this.props.label != null)
        {
            return <label htmlFor={this.props.id}>{this.props.label}</label>
        }
    }

    /**
     * Rendert die Komponente.
     */
    public render(): JSX.Element
    {
        var { style, children, hint } = this.props;

        return (
            <InputContainer style={style}>
                {this.getLabel()}
                <div className="textbox">
                    <InputBase {...this.props} />
                    {children}
                </div>
                {
                    hint &&
                    <InputHint style={{
                        marginTop: 5,
                    }}>
                        {hint}
                    </InputHint>
                }
            </InputContainer>
        );
    }
}